import { requestJson } from "./apiClient";
import { NEWS_CONFIG } from "../config/newsConfig";

export const getPushServerConfig = async () => {
  return requestJson({
    url: `${NEWS_CONFIG.apiUrl}?type=push_config`,
    operation: "push-config",
    timeoutMs: 5000,
    defaultMessage: "دریافت تنظیمات اعلان‌ها با مشکل مواجه شد",
    method: "GET",
    headers: { Accept: "application/json" },
  });
};

export const registerPushDevice = async ({
  installationId,
  subscription,
  platform,
}) => {
  const json = subscription?.toJSON ? subscription.toJSON() : subscription;
  const endpoint = String(json?.endpoint || "").trim();
  const p256dh = String(json?.keys?.p256dh || "").trim();
  const auth = String(json?.keys?.auth || "").trim();

  return requestJson({
    url: `${NEWS_CONFIG.apiUrl}?type=push_register`,
    operation: "push-register",
    timeoutMs: 7000,
    defaultMessage: "فعال‌سازی اعلان‌ها با مشکل مواجه شد",
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({
      installation_id: installationId,
      endpoint,
      p256dh,
      auth,
      platform,
    }),
  });
};

export const unregisterPushDevice = async ({ installationId, platform }) => {
  return requestJson({
    url: `${NEWS_CONFIG.apiUrl}?type=push_unregister`,
    operation: "push-unregister",
    timeoutMs: 7000,
    defaultMessage: "غیرفعال‌سازی اعلان‌ها با مشکل مواجه شد",
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({
      installation_id: installationId,
      platform,
    }),
  });
};
